import { render } from "./LoadingProgress.vue?vue&type=template&id=2aac8811&scoped=true"
import script from "./LoadingProgress.vue?vue&type=script&lang=js"
export * from "./LoadingProgress.vue?vue&type=script&lang=js"

import "./LoadingProgress.vue?vue&type=style&index=0&id=2aac8811&scoped=true&lang=scss"

import exportComponent from "J:\\20_Mitarbeiter\\Christian\\240626_Logo_Europa_Babylon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aac8811"]])

export default __exports__